<template>
  <div class="recomCoupons">
    <img
      class="title"
      src="../../../assets/img/pullNew/couponTitle.png"
      alt=""
    >
    <ul>
      <li
        v-for="item in couponInfoList"
        :key="item.couponId"
        @click="clickBtn(item)"
      >
        <div class="left">
          <p
            class="discountAmount"
            v-if="item.discountType === 1"
          >
            <span>￥</span>{{item.discountAmount}}
          </p>
          <p
            class="discountAmount"
            v-else
          >
            {{item.discountAmount}}<span>折</span>
          </p>
          <p>满{{item.usableCondition}}可用</p>
        </div>
        <div class="center">
          <p class="frontEndName">{{item.frontEndName}}</p>
          <p class="status">
            <span v-if="item.productionFitType === 1">所有产品可用</span>
            <span v-else-if="item.productionFitType === 2 || item.productionFitType === 3">指定产品可用</span>
            <span v-else-if="item.productionFitType === 4">所有套餐可用</span>
            <span v-else>指定产品套餐可用</span>
          </p>
          <template v-if="item.userAlreadyGet === 1">
            <p v-if="item.effectiveTimeType === 1">{{item.djs}}</p>
            <p v-else>{{detailTime(item.effectiveTimeEnd)}}到期</p>
          </template>
          <template v-else>
            <p v-if="item.effectiveTimeType === 1">领取后{{item.effectiveDays}}天有效</p>
            <p v-else>{{detailTime(item.effectiveTimeBegin)}} - {{detailTime(item.effectiveTimeEnd)}}</p>
          </template>

        </div>
        <div class="right">
          {{item.userAlreadyGet === 1 ? '去使用' : '免费领取'}}
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { reqReceiveCoupon } from '@/api/coupon/index';
import { dateTime, setBaseUrl, replaceHyphens } from '@/utils/tools';
import { mapState } from 'vuex';
import wx from 'weixin-js-sdk';

export default {
  data() {
    return {
      timer: null,
    };
  },
  props: {
    couponInfoList: {
      type: Array,
    },
  },
  computed: {
    ...mapState(['userInfo']),
  },
  mounted() {
    this.SETINTERVAL();
  },
  methods: {
    clickBtn(data) {
      if (!this.userInfo.id && this.$root.$data.isApp) {
        this.$sendToApp('login');
        return;
      }
      if (!this.userInfo.id && this.$root.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        if (searchParams) {
          const params = searchParams.split('&');
          const paramsMap = new Map();

          params.forEach((item) => {
            const [key, value] = item.split('=');
            console.log('key', key, value);
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
          }
          url = `${domain}?${query}`;
        } else {
          url = `${domain}`;
        }
        const redirctUrl = encodeURIComponent(`/subPackages/customShareWebview/webView?url=${encodeURIComponent(url)}`);
        const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
        wx.miniProgram.redirectTo({
          url: path,
        });
        return;
      }
      if (!this.userInfo.id) {
        const { path, query } = this.$route;
        this.$router.push({ path: '/registrationLogin', query: { redirect: path, ...query } });
        return;
      }

      const { userAlreadyGet, couponId } = data;
      if (userAlreadyGet === 1) { // 已领取
        this.goToPage(data);
        return;
      }
      this.receive(couponId);
    },
    goToPage(data) { // 跳转到相应的页面
      const { productionFitType } = data;
      let routeUrl = '';
      // 适用产品类型 1 所有产品 2 限定产品 3 限定产品分类 4 所有套餐 5 限定套餐
      if (productionFitType === 1 || productionFitType === 4) {
        // 判断是否App
        if (this.$root.$data.isApp) {
          this.$sendToApp('goToHomePage');
          return;
        }
        this.$router.push({
          path: '/home',
          query: {
            code: 2,
          },
        });
        return;
      }
      if (productionFitType === 2) {
        const { productIds } = data;
        if (productIds.length > 1) {
          const productId = productIds.join();
          if (this.$root.$data.isApp) {
            this.$sendToApp(
              'openNewWebView',
              { url: `${setBaseUrl('')}/ark/productList?type=5&productId=${productId}` },
              false,
            );
            return;
          }
          routeUrl = this.$router.resolve({
            path: '/productList',
            query: {
              type: 5,
              productId,
            },
          });
          window.open(routeUrl.href, '_blank');
        } else {
          // 判断是否App
          if (this.$root.$data.isApp) {
            this.$sendToApp('goCourseDetail', Number(productIds[0]), false);
            return;
          }
          sessionStorage.setItem('back', 'back');
          this.$router.push({
            path: '/courseDetail',
            query: {
              courseId: productIds[0],
            },
          });
        }
        return;
      }
      if (productionFitType === 3) {
        const { productCatalogIds } = data;
        const productCategoryId = productCatalogIds.join();
        if (this.$root.$data.isApp) {
          this.$sendToApp(
            'openNewWebView',
            {
              url: `${setBaseUrl(
                '',
              )}/ark/productList?type=3&productCategoryId=${productCategoryId}`,
            },
            false,
          );
          return;
        }
        routeUrl = this.$router.resolve({
          path: '/productList',
          query: {
            type: 3,
            productCategoryId,
          },
        });
        window.open(routeUrl.href, '_blank');
        return;
      }
      if (productionFitType === 5) {
        const { packageIds } = data;
        if (packageIds.length > 1) {
          const packageId = packageIds.join();
          if (this.$root.$data.isApp) {
            this.$sendToApp(
              'openNewWebView',
              { url: `${setBaseUrl('')}/ark/combinationList?packageIds=${packageId}` },
              false,
            );
            return;
          }
          routeUrl = this.$router.resolve({
            path: '/combinationList',
            query: {
              packageIds: packageId,
            },
          });
          window.open(routeUrl.href, '_blank');
        } else {
          // 判断是否App
          if (this.$root.$data.isApp) {
            this.$sendToApp('goToCombinationCourse', Number(packageIds[0]), false);
            return;
          }
          sessionStorage.setItem('back', true);
          this.$router.push({
            path: '/combinationCourse',
            query: {
              combinationId: packageIds[0],
            },
          });
        }
      }
    },
    async receive(couponId) {
      const { code, msg } = await reqReceiveCoupon({
        couponId,
        fitPlatform: 1,
        fitEndPoint: 4,
        isLink: 0,
        terminalMark: this.$global.terminalMark
      });
      if (code === 0) {
        this.$toast('优惠券领取成功');
        this.$emit('resetInfo');
      } else {
        this.$toast.fail(msg);
      }
    },
    SETINTERVAL() {
      this.timer = setInterval(() => {
        this.couponInfoList.forEach((item) => {
          if (item.effectiveTimeType === 1 && item.userAlreadyGet === 1) {
            const endTime = new Date(replaceHyphens(item.linkExpireTime)).getTime();
            const nowtime = new Date().getTime();
            const rightTime = endTime - nowtime;
            if (rightTime > 0) {
              const days = Math.floor(rightTime / 1000 / 60 / 60 / 24);
              const hh = Math.floor((rightTime / 1000 / 60 / 60) % 24);
              const mm = Math.floor((rightTime / 1000 / 60) % 60);
              const ss = Math.floor((rightTime / 1000) % 60);
              let str = '';
              if (days > 0) {
                str = `还剩下${days}天到期`;
              } else {
                str = `到期倒计时：${hh.toString().padStart(2, '0')} : ${mm
                  .toString()
                  .padStart(2, '0')} : ${ss.toString().padStart(2, '0')}`;
              }
              this.$set(item, 'djs', str);
            } else {
              this.$set(item, 'djs', '到期倒计时：00 : 00 : 00');
            }
          }
        });
      }, 1000);
    },
    detailTime(time) {
      const {
        year, month, day,
      } = dateTime(new Date(time.replace(/-/g, '/')).getTime());
      return `${year}.${month}.${day}`;
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
<style scoped lang="scss">
.recomCoupons {
  width: 686px;
  margin: 48px auto;
  padding: 0 24px 24px;
  background: linear-gradient(180deg, #fbe8d5 0%, #ffe6cd 100%);
  border: 2px solid #ffe39d;
  border-radius: 40px;
  .title {
    display: block;
    width: 474px;
    height: 102px;
    margin: 0 auto 48px;
  }
  ul {
    li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 638px;
      height: 212px;
      margin-bottom: 24px;
      font-size: 28px;
      background: url('../../../assets/img/pullNew/couponBg.png') no-repeat;
      background-size: 100% 100%;
      .left {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        box-sizing: border-box;
        width: 30%;
        p {
          width: 100%;
          margin: 10px 0;
          color: #fff;
          text-align: center;
        }
        .discountAmount {
          font-size: 48px;
          span {
            font-size: 22px;
          }
        }
      }
      .center {
        display: flex;
        flex-direction: column;
        width: 62%;
        padding: 0 25px;
        p {
          margin: 15px 0;
          color: #c4803e;
          font-size: 24px;
        }
        .frontEndName {
          width: 100%;
          overflow: hidden;
          color: #a96523;
          font-weight: 500;
          font-size: 32px;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .right {
        display: flex;
        align-items: center;
        width: 8%;
        color: #fff;
        font-size: 24px;
        letter-spacing: 10px;
        writing-mode: vertical-lr;
      }
    }
  }
}
</style>
